<template>
  <q-tab-pane name="members" class="q-pb-sm q-pa-none">
    <div class="bg-blue-grey-11 text-blue-grey-14 q-pa-md row items-center">
      <q-icon name="info" style="font-size: 1.25rem"/>

      <span class="on-right">
        {{ $t('member_count') }} <span class="text-weight-bold">{{ memberCount }}</span> {{ $tc('member', memberCount) }}
      </span>
    </div>

    <team-member-list class="q-py-sm" :team="team"></team-member-list>

    <invite-member class="q-px-md" :team="team"></invite-member>
  </q-tab-pane>
</template>

<script>
  import InviteMember from 'components/Team/Members/InviteMember.vue'
  import TeamMemberList from 'components/Team/Members/TeamMemberList.vue'
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters(['team']),

      memberCount () {
        return this.team.members.filter(member => member.role_id < 3).length
      }
    },

    components: {
      InviteMember,
      TeamMemberList
    }
  }
</script>
